<div class="col-lg-12 marquee-blq">

    <!-- <p class="orig">

        <span class="grey">sala de prensa.</span> &nbsp;&nbsp;&nbsp;&nbsp; noticias.&nbsp;&nbsp;&nbsp;&nbsp; <span class="grey">retailCo en medios.</span> &nbsp;&nbsp;&nbsp;&nbsp;retailCo ahora. &nbsp;&nbsp;&nbsp;&nbsp; <span class="grey">somos noticia.</span> &nbsp;&nbsp;&nbsp;&nbsp; lo que dicen de nosotros. &nbsp;&nbsp;&nbsp;&nbsp; <span class="grey">retailCo damos que hablar.</span>&nbsp;&nbsp;&nbsp;&nbsp;
        <span class="grey">sala de prensa.</span> &nbsp;&nbsp;&nbsp;&nbsp; noticias.&nbsp;&nbsp;&nbsp;&nbsp; <span class="grey">retailCo en medios.</span> &nbsp;&nbsp;&nbsp;&nbsp;retailCo ahora. &nbsp;&nbsp;&nbsp;&nbsp; <span class="grey">somos noticia.</span> &nbsp;&nbsp;&nbsp;&nbsp; lo que dicen de nosotros. &nbsp;&nbsp;&nbsp;&nbsp; <span class="grey">retailCo damos que hablar.</span>&nbsp;&nbsp;&nbsp;&nbsp;
        <span class="grey">sala de prensa.</span> &nbsp;&nbsp;&nbsp;&nbsp; noticias.&nbsp;&nbsp;&nbsp;&nbsp; <span class="grey">retailCo en medios.</span> &nbsp;&nbsp;&nbsp;&nbsp;retailCo ahora. &nbsp;&nbsp;&nbsp;&nbsp; <span class="grey">somos noticia.</span> &nbsp;&nbsp;&nbsp;&nbsp; lo que dicen de nosotros. &nbsp;&nbsp;&nbsp;&nbsp; <span class="grey">retailCo damos que hablar.</span>&nbsp;&nbsp;&nbsp;&nbsp;


      </p> -->
    <p class="orig">
        <span *ngFor="let item of marqueeHome_items">
            <span [ngClass]="{'grey': item.grey}">{{item.text}}</span>
            <span class="preline_spacer">{{marqueeHome_spacer}}</span>
        </span>
    </p>


 </div>
